import React from 'react';
import styles from './styles.module.scss';
import { formatCurrency } from '@wolffun/system-currency';
import icThg from '/assets/img/thetan_gem_V2.png';

const PoolBalance = ({
  remainingInPool
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.accountBalance
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.gTHCBalance
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "THG Balance")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, remainingInPool ? formatCurrency(remainingInPool, {
    withCurrency: false,
    precision: 2
  }) : '-----'))), /*#__PURE__*/React.createElement("div", {
    className: styles.thgIcon
  }, /*#__PURE__*/React.createElement("img", {
    src: icThg,
    alt: ""
  })));
};

export default PoolBalance;